export class CalamityActionHistoryModel {
    calId : string ;
    calCalamityActionId: string ;
    calLogHistoryTypeId: string = null;
    calFreeText:string = null; 
    calCreatedDate: Date = null;
    calCreatedBy: string = null ;
    calLastModifiedDate: Date = null;
    calLastModifiedBy:  string = null;
    }